import { resourceTypes } from '../viewAccountBalancesPage/viewAccountBalances.constants';

const initialState = {
  countryTaxType: null,
  countryTaxTypes: [],
  isLoadingCountryTaxTypes: false,
  taxEntries: [],
  taxEntriesLoading: false,
  submittingTaxEntry: false,
  taxEntryData: {
    subledgerJournals: [],
    GLJournals: [],
    attachments: [],
  },
  taxEntryForApprovalData: {
    attachments: [],
    taxEntryId: null,
  },
  taxEntryId: 0,
  taxPeriods: {
    periodFrom: null,
    periodTo: null,
  },
  accountActivity: {
    entryType: null,
    entryActivity: null,
    accountActivityLoading: false,
    accountActivityCollection: [],
    accountId: null,
    accounts: [],
  },
  subledgerTaxEntries: [],
  fetchingProposedJournals: false,
  fetchingProposedReclassJournals: false,
  proposedJournals: {
    slJournal: [],
    slDeferredBalance: [],
  },
  proposedJournalsForReclass: [],
  subledgerGlAccounts: [],
  accounts: [],
  taxEntriesForApprovalLoading: false,
  taxEntriesForApproval: [],
  lockIdForTaxEntriesBatch: null,
  taxEntriesReviewProgress: 0,
  taxEntriesReviewInProgress: false,
  taxEntriesDeclineInProgress: false,
  modals: {
    showAddEntryModal: false,
  },
  connections: [],
  connection: null,
  notificationsLoading: false,
  notifications: null,
  diagnosticsLoading: false,
  diagnostics: null,
  batchTaxEntries: {
    taxEntriesLoading: false,
    isUploadingTaxEntriesToImport: false,
    taxEntriesToImport: [],
    chosenTaxEntry: null,
    insertedTaxEntries: 0,
  },
  businessCode: null,
  businessCodes: [],
  resourceTypeForAccountBalances: resourceTypes.business,
  accountBalancesLoading: false,
  accountBalances: [],
  taxEntriesTree: {},
  isLoadingTaxEntriesTree: false,
  typeDescriptions: {},
  isLoadingTypeDescriptions: false,
  activityDescriptions: {},
  isLoadingActivityDescriptions: false,
  deferredTaxRate: 0,
  isLoadingDeferredTaxRate: false,
  stateApportionmentRate: 0,
  isLoadingObligationRates: false,
  tbeErrors: [],
  isLoadingTbeErrors: false,
};

export default initialState;
